import { Tag } from "@samdesk/components/Tag";
import theme from "theme";

export const NewTag = () => {
	return (
		<Tag
			label="New"
			textColor={theme.palette.eventType.text["life_cycle"]}
			backgroundColor={theme.palette.eventType.surface["life_cycle"]}
		/>
	);
};
